
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"31","height":"31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.643 10.036a.955.955 0 00-.271 0 3.712 3.712 0 01-3.591-3.72 3.735 3.735 0 013.733-3.733 3.735 3.735 0 013.733 3.733 3.732 3.732 0 01-3.604 3.72zM26.854 18.988c-1.447.968-3.475 1.33-5.348 1.085.491-1.06.75-2.235.762-3.475 0-1.292-.284-2.519-.826-3.59 1.912-.26 3.94.102 5.399 1.071 2.04 1.343 2.04 3.552.013 4.909zM8.318 10.036a.955.955 0 01.271 0 3.712 3.712 0 003.591-3.72 3.726 3.726 0 00-3.733-3.733 3.724 3.724 0 00-3.72 3.733 3.712 3.712 0 003.591 3.72zM8.46 16.598c0 1.253.272 2.441.763 3.513-1.822.194-3.72-.194-5.115-1.11-2.041-1.357-2.041-3.566 0-4.922 1.382-.93 3.332-1.304 5.166-1.098a8.212 8.212 0 00-.813 3.617zM15.655 20.499a1.46 1.46 0 00-.336 0 4.424 4.424 0 01-4.275-4.43 4.454 4.454 0 014.456-4.444 4.443 4.443 0 014.443 4.443 4.435 4.435 0 01-4.288 4.43zM11.457 23.172c-1.95 1.305-1.95 3.45 0 4.74 2.222 1.486 5.864 1.486 8.086 0 1.95-1.304 1.95-3.448 0-4.74-2.209-1.485-5.851-1.485-8.086 0z","fill":"#292D32"}})])
          )
        }
      }
    